// extracted by css-extract-rspack-plugin
module.exports =  {"root":"BookkeepingManagerTableRow__root___LUNdx","text":"BookkeepingManagerTableRow__text___J9snU"};